// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TemplateContact_wrapper__wLVH_"};